import {
  ALL_CRYPTO,
  amountWithCurrencySymbol,
  CurrencyCode,
} from '@/helpers/currency';

export const formatAmount = (amount: number) =>
  amount >= 10_000 ? amount.toLocaleString('en-US') : amount;

export const formatCurrencyAmount = (amount: number, currencyCode?: string) =>
  amountWithCurrencySymbol(currencyCode, formatAmount(amount), {
    wholeRounding: true,
  });

export const formatWageredAmount = (amount: number, currencyCode?: string) =>
  amountWithCurrencySymbol(currencyCode, formatAmount(amount), {
    wholeRounding: true,
    spaced: true,
  });

// Levels track wagering/rewards in fiat - crypto wallets fall back to USD.
export const normalizeCurrencyCode = (currencyCode?: string) =>
  currencyCode && ALL_CRYPTO.includes(currencyCode as CurrencyCode)
    ? CurrencyCode.USD
    : currencyCode;
